import { Lock } from '@egr/wcf/modules/utils/async';
import { open, write, close , flush } from './Filesystem/Wrapper';

export class DebugLogFile {
    private lock = new Lock();
    private loggedEntries = 0;
    private fileDescriptor: string | null;

    public constructor(path: string, private maxEntries = 0, private flushInterval = 5000) {
        void (async () => {
            // lock the lock in order to ensure that the `fileDescriptor` is opened
            // before any message is written
            const context = await this.lock.acquireLock();
            this.fileDescriptor = await open(path, 'w', '');
            context.unlock();
        })();
        void this.triggerFlush();
    }

    public log = async (message: string): Promise<void> => {
        if (this.loggedEntries >= this.maxEntries || this.fileDescriptor == null) {
            if (this.fileDescriptor != null) {
                void close(this.fileDescriptor);
                this.fileDescriptor = null;
            }

            return;
        }

        const context = await this.lock.acquireLock();
        try {
            this.loggedEntries++;
            await write(this.fileDescriptor, message);
        } finally {
            context.unlock();
        }
    };

    private triggerFlush = async (): Promise<void> => {
        const context = await this.lock.acquireLock();
        try {
            if (this.fileDescriptor != null && this.loggedEntries > 0) {
                await flush(this.fileDescriptor);
                window.setTimeout(this.triggerFlush, this.flushInterval);
            }
        } finally {
            context.unlock();
        }
    };
}